import _Object$assign from '@babel/runtime-corejs3/core-js-stable/object/assign';
import { c as classNames } from '../../shared/bind-a2a3a613.js';
import { getTestId } from '../../utils/testId.js';
import { interpolateWithHtml } from '../../utils/interpolateWithHtml.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var styles = {
  "unit-base": "4",
  "bubble": "web_ui__Bubble__bubble",
  "content": "web_ui__Bubble__content",
  "footer": "web_ui__Bubble__footer",
  "inverse": "web_ui__Bubble__inverse",
  "default": "web_ui__Bubble__default",
  "narrow": "web_ui__Bubble__narrow",
  "tight": "web_ui__Bubble__tight",
  "wide": "web_ui__Bubble__wide"
};

var BUBBLE_STYLING_VALUES = ['default', 'narrow', 'tight', 'wide'];
/* ---------- Back-compat shims (public API) ---------- */
var BUBBLE_STYLING = {
  Default: 'default',
  Narrow: 'narrow',
  Tight: 'tight',
  Wide: 'wide'
};

/* ---------- Type definitions ---------- */

var BubbleBase = function BubbleBase(_ref) {
  var _ref$styling = _ref.styling,
    styling = _ref$styling === void 0 ? 'narrow' : _ref$styling,
    children = _ref.children,
    text = _ref.text,
    footer = _ref.footer,
    inverse = _ref.inverse,
    html = _ref.html,
    testId = _ref.testId;
  var cssClasses = classNames.bind(styles);
  var renderText = function renderText() {
    var contentClass = cssClasses(styles.content);
    var element = /*#__PURE__*/jsx("div", {
      className: contentClass,
      "data-testid": getTestId(testId, 'content'),
      children: text
    });
    if (html) return interpolateWithHtml(element);
    return element;
  };
  var renderChildren = function renderChildren() {
    if (html) return interpolateWithHtml(children);
    return children;
  };
  var renderContent = function renderContent() {
    var bubbleContentClass = cssClasses(styling);
    return /*#__PURE__*/jsxs("div", {
      className: bubbleContentClass,
      children: [renderText(), renderChildren()]
    });
  };
  var bubbleClass = cssClasses(styles.bubble, {
    inverse: inverse
  });
  var footerClass = cssClasses(styling, styles.content, styles.footer);
  return /*#__PURE__*/jsxs("div", {
    className: bubbleClass,
    "data-testid": testId,
    children: [renderContent(), footer ? /*#__PURE__*/jsx("div", {
      className: footerClass,
      "data-testid": getTestId(testId, 'footer'),
      children: footer
    }) : null]
  });
};

/** The public component type: a React component value that also has deprecated statics */

/** Exported component: arrow fn + statics, deprecations intact, docgen-friendly */
var Bubble = _Object$assign(BubbleBase, {
  /** @deprecated Use string unions, e.g. styling="narrow" */
  Styling: BUBBLE_STYLING
});

export { BUBBLE_STYLING, BUBBLE_STYLING_VALUES, Bubble, Bubble as default };
//# sourceMappingURL=Bubble.js.map
